export const GET_VERIFIED_BANK_ACCOUNT_DETAILS = "GET_VERIFIED_BANK_ACCOUNT_DETAILS";
export const GET_VERIFIED_BANK_ACCOUNT_DETAILS_LOADING = "GET_VERIFIED_BANK_ACCOUNT_DETAILS_LOADING";
export const GET_VERIFIED_BANK_ACCOUNT_DETAILS_SUCCESS = "GET_VERIFIED_BANK_ACCOUNT_DETAILS_SUCCESS";
export const GET_VERIFIED_BANK_ACCOUNT_DETAILS_ERROR = "GET_VERIFIED_BANK_ACCOUNT_DETAILS_ERROR";
export const CLEAR_VERIFIED_BANK_ACCOUNT_DETAILS = "CLEAR_VERIFIED_BANK_ACCOUNT_DETAILS";

export const GET_VERIFIED_UPI_ID_DETAILS = "GET_VERIFIED_UPI_ID_DETAILS";
export const GET_VERIFIED_UPI_ID_DETAILS_LOADING = "GET_VERIFIED_UPI_ID_DETAILS_LOADING";
export const GET_VERIFIED_UPI_ID_DETAILS_SUCCESS = "GET_VERIFIED_UPI_ID_DETAILS_SUCCESS";
export const GET_VERIFIED_UPI_ID_DETAILS_ERROR = "GET_VERIFIED_UPI_ID_DETAILS_ERROR";
export const CLEAR_VERIFIED_UPI_ID_DETAILS = "CLEAR_VERIFIED_UPI_ID_DETAILS";

export const getVerifiedBankAccountDetails = (body) => ({ type: GET_VERIFIED_BANK_ACCOUNT_DETAILS, body });
export const clearVerifiedBankAccountDetails = () => ({ type: CLEAR_VERIFIED_BANK_ACCOUNT_DETAILS, data: {} });

export const getVerifiedUPIIdDetails = (body) => ({ type: GET_VERIFIED_UPI_ID_DETAILS, body });
export const clearVerifiedUPIIdDetails = () => ({ type: CLEAR_VERIFIED_UPI_ID_DETAILS, data: {} });
